import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [interest, setInterest] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email, name, interest, source: "newsletter_page" });
      setDone(true);
    } catch {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="newsletter-page">
      <section className="max-w-reading mx-auto px-6 py-24 md:py-32 text-center">
        <div className="eyebrow text-oc-coral mb-6">The Newsletter</div>
        <h1 className="font-editorial text-4xl md:text-6xl text-oc-ink leading-[1.05]">
          New interviews, operator insights, and curated collections, occasionally.
        </h1>
        <p className="mt-8 font-editorial text-lg md:text-xl text-oc-ink-soft leading-relaxed">
          We do not use aggressive pop-ups. We do not send filler. We send you what we publish, when we publish it, and nothing more.
        </p>

        {done ? (
          <p data-testid="newsletter-success-full" className="mt-16 font-editorial text-2xl text-oc-blue">
            You're on the list. Welcome to Operating Class.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-14 max-w-md mx-auto space-y-4 text-left">
            <label className="block">
              <span className="eyebrow text-oc-ink-muted mb-2 block">Your email *</span>
              <input
                data-testid="newsletter-email-input-full"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui"
              />
            </label>
            <label className="block">
              <span className="eyebrow text-oc-ink-muted mb-2 block">Name (optional)</span>
              <input
                data-testid="newsletter-name-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui"
              />
            </label>
            <label className="block">
              <span className="eyebrow text-oc-ink-muted mb-2 block">Interest area (optional)</span>
              <input
                data-testid="newsletter-interest"
                value={interest}
                onChange={(e) => setInterest(e.target.value)}
                placeholder="e.g. Manufacturing, hiring, succession..."
                className="w-full h-12 px-4 bg-white border border-oc-hairline focus:border-oc-ink outline-none font-ui"
              />
            </label>
            <button
              data-testid="newsletter-submit-full"
              disabled={loading}
              className="w-full h-14 bg-oc-blue text-white font-ui text-sm font-bold uppercase tracking-widest hover:bg-oc-blue-hover disabled:opacity-60"
            >
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        )}
      </section>
    </div>
  );
}
